import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import { environment } from 'environment-configurations';
import * as i2 from 'file-upload-library';
import * as i3 from 'primeng/accordion';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/table';
import * as i6 from 'primeng/api';
import * as i7 from '@angular/material/icon';
import * as i8 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class LibLeaveSummaryService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getLeaveSummaryDetails(leaveId) {
        return this.http.get(`/vd/formBuilder/lms/get/leaveReqeust/${leaveId}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibLeaveSummaryService.ɵfac = function LibLeaveSummaryService_Factory(t) { return new (t || LibLeaveSummaryService)(i0.ɵɵinject(i1.HttpClient)); };
LibLeaveSummaryService.ɵprov = i0.ɵɵdefineInjectable({ token: LibLeaveSummaryService, factory: LibLeaveSummaryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibLeaveSummaryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LibLeaveSummaryComponent_div_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "p", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵelementStart(5, "p", 8);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const allotment_r5 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", allotment_r5 == null ? null : allotment_r5.leaveDate, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", allotment_r5 == null ? null : allotment_r5.leaveUnitType, " ");
} }
function LibLeaveSummaryComponent_ng_template_82_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵlistener("click", function LibLeaveSummaryComponent_ng_template_82_div_5_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r10); const loadData_r6 = i0.ɵɵnextContext().$implicit; const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.openDoc(loadData_r6); });
    i0.ɵɵelementStart(3, "mat-icon", 23);
    i0.ɵɵtext(4, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 24);
    i0.ɵɵelementStart(6, "i", 25);
    i0.ɵɵlistener("click", function LibLeaveSummaryComponent_ng_template_82_div_5_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r10); const loadData_r6 = i0.ɵɵnextContext().$implicit; const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.download(loadData_r6); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibLeaveSummaryComponent_ng_template_82_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "p", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, LibLeaveSummaryComponent_ng_template_82_div_5_Template, 7, 0, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loadData_r6 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loadData_r6 == null ? null : loadData_r6.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", loadData_r6.fileName !== null);
} }
function LibLeaveSummaryComponent_ng_template_83_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, " No records found ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", 3);
} }
function LibLeaveSummaryComponent_div_85_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵelementStart(2, "button", 27);
    i0.ɵɵelementStart(3, "mat-icon");
    i0.ɵɵtext(4, "check");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 28);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", (ctx_r3.leaveSummaryDetails == null ? null : ctx_r3.leaveSummaryDetails.leaveStatus) ? ctx_r3.leaveSummaryDetails == null ? null : ctx_r3.leaveSummaryDetails.leaveStatus : "--", " ");
} }
function LibLeaveSummaryComponent_86_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵelementStart(2, "button", 29);
    i0.ɵɵelementStart(3, "mat-icon");
    i0.ɵɵtext(4, "info");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 28);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "h6", 30);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", (ctx_r14.leaveSummaryDetails == null ? null : ctx_r14.leaveSummaryDetails.leaveStatus) ? ctx_r14.leaveSummaryDetails == null ? null : ctx_r14.leaveSummaryDetails.leaveStatus : "--", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (ctx_r14.leaveSummaryDetails == null ? null : ctx_r14.leaveSummaryDetails.leaveRejectReason) ? ctx_r14.leaveSummaryDetails == null ? null : ctx_r14.leaveSummaryDetails.leaveRejectReason : "--", " ");
} }
function LibLeaveSummaryComponent_86_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LibLeaveSummaryComponent_86_ng_template_0_Template, 9, 2, "ng-template");
} }
class LibLeaveSummaryComponent {
    constructor(leaveSummaryService, uploadService) {
        this.leaveSummaryService = leaveSummaryService;
        this.uploadService = uploadService;
        this.observableSubscription$ = new Subject();
        this.leaveSummaryDetails = [];
    }
    ngOnInit() {
        this.getLeaveSummaryDetails();
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
    }
    getLeaveSummaryDetails() {
        this.leaveId = 'leaveRequestId' in sessionStorage ? parseInt(sessionStorage.getItem('leaveRequestId')) : null;
        if (this.leaveId) {
            this.leaveSummaryService.getLeaveSummaryDetails(this.leaveId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                this.leaveSummaryDetails = response.data || null;
            });
        }
    }
    openDoc(item) {
        var _a;
        //const baseUrl = environment.docs.replace(':5651/docs', '');
        const baseUrl = environment.appUrl;
        const docPath = (_a = item.fileLocation) === null || _a === void 0 ? void 0 : _a.substring(9);
        window.open(`${baseUrl}/${docPath}`, '_blank');
    }
    download(file) {
        var _a, _b, _c;
        //const baseUrl = environment.docs.replace(':5651/docs', '');
        const baseUrl = environment.appUrl + '/';
        this.uploadService.downloadDocuments(baseUrl + ((_a = file.fileLocation) === null || _a === void 0 ? void 0 : _a.substring(9)), this.isFBUser ? (_b = file.fileLocation) === null || _b === void 0 ? void 0 : _b.split('/').slice(-1)[0] : (_c = file.fileLocation) === null || _c === void 0 ? void 0 : _c.substring(9));
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
LibLeaveSummaryComponent.ɵfac = function LibLeaveSummaryComponent_Factory(t) { return new (t || LibLeaveSummaryComponent)(i0.ɵɵdirectiveInject(LibLeaveSummaryService), i0.ɵɵdirectiveInject(i2.FileUploadLibraryService)); };
LibLeaveSummaryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibLeaveSummaryComponent, selectors: [["lib-leave-summary"]], decls: 87, vars: 19, consts: [[1, "container-fluid", "leave_summary", "p-0", "m-0", "mt-2"], [1, "row"], [1, "col-12"], [1, "mb-0"], [1, "role-accordion"], ["header", "Leave Details"], [1, "col-4"], [1, "leave_details_heading"], [1, "leave_details_content"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "col-6"], [1, "row", "leave-details-card-row"], [1, "labelHeading", "headlbl"], ["styleClass", "table-striped-simple", 3, "value", "resizableColumns"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], ["class", "col-12 leave_details_confirm_container mb-2", 4, "ngIf"], [4, "ngIf"], [1, "file-name"], ["class", "row file-icons", 4, "ngIf"], [1, "row", "file-icons"], [1, "mr-2", "padding0"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons", "icon-color"], [1, "download-icon"], ["title", "Download", 1, "fa", "fa-download", "pr-2", "icn", "icon-color", 3, "click"], [1, "col-12", "leave_details_confirm_container", "mb-2"], ["pButton", "", "icon", "button", 1, "p-button-text", "p-button-rounded", "p-button-success", "mb-0"], [1, "leave_details_info", "pb-2"], ["pButton", "", "icon", "button", 1, "p-button-text", "p-button-rounded", "p-button-danger", "mb-0"], [1, "leave_details_heading", "ml-4"]], template: function LibLeaveSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5", 3);
        i0.ɵɵtext(4, "Leave Summary");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 1);
        i0.ɵɵelementStart(6, "div", 2);
        i0.ɵɵelementStart(7, "p-accordion", 4);
        i0.ɵɵelementStart(8, "p-accordionTab", 5);
        i0.ɵɵelementStart(9, "div", 1);
        i0.ɵɵelementStart(10, "div", 6);
        i0.ɵɵelementStart(11, "p", 7);
        i0.ɵɵtext(12, " Emp.Id ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "p", 8);
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 6);
        i0.ɵɵelementStart(16, "p", 7);
        i0.ɵɵtext(17, " Emp.Name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "p", 8);
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 6);
        i0.ɵɵelementStart(21, "p", 7);
        i0.ɵɵtext(22, " Designation ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "p", 8);
        i0.ɵɵtext(24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 1);
        i0.ɵɵelementStart(26, "div", 6);
        i0.ɵɵelementStart(27, "p", 7);
        i0.ɵɵtext(28, " Reporting Manager ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "p", 8);
        i0.ɵɵtext(30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 6);
        i0.ɵɵelementStart(32, "p", 7);
        i0.ɵɵtext(33, " Leave Start Date ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "p", 8);
        i0.ɵɵtext(35);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "div", 6);
        i0.ɵɵelementStart(37, "p", 7);
        i0.ɵɵtext(38, " Leave End Date ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "p", 8);
        i0.ɵɵtext(40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 1);
        i0.ɵɵelementStart(42, "div", 6);
        i0.ɵɵelementStart(43, "p", 7);
        i0.ɵɵtext(44, " Date of Application ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "p", 8);
        i0.ɵɵtext(46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "div", 1);
        i0.ɵɵelementStart(48, "div", 2);
        i0.ɵɵelementStart(49, "p", 7);
        i0.ɵɵtext(50, " Applied duration - ");
        i0.ɵɵelementStart(51, "span");
        i0.ɵɵtext(52);
        i0.ɵɵpipe(53, "number");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(54, LibLeaveSummaryComponent_div_54_Template, 7, 2, "div", 9);
        i0.ɵɵelementStart(55, "div", 1);
        i0.ɵɵelementStart(56, "div", 2);
        i0.ɵɵelementStart(57, "p", 7);
        i0.ɵɵtext(58, " Leave type ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(59, "p", 8);
        i0.ɵɵtext(60);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(61, "div", 1);
        i0.ɵɵelementStart(62, "div", 2);
        i0.ɵɵelementStart(63, "p", 7);
        i0.ɵɵtext(64, " Reason for Leave ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(65, "p", 8);
        i0.ɵɵtext(66);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(67, "div", 1);
        i0.ɵɵelementStart(68, "div", 10);
        i0.ɵɵelementStart(69, "p", 7);
        i0.ɵɵtext(70, " Phone Number ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "p", 8);
        i0.ɵɵtext(72);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(73, "div", 10);
        i0.ɵɵelementStart(74, "p", 7);
        i0.ɵɵtext(75, " Alternate Phone Number ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(76, "p", 8);
        i0.ɵɵtext(77);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(78, "div", 11);
        i0.ɵɵelementStart(79, "div", 12);
        i0.ɵɵtext(80, "Uploaded Files");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(81, "p-table", 13);
        i0.ɵɵtemplate(82, LibLeaveSummaryComponent_ng_template_82_Template, 6, 2, "ng-template", 14);
        i0.ɵɵtemplate(83, LibLeaveSummaryComponent_ng_template_83_Template, 3, 1, "ng-template", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(84, "div", 1);
        i0.ɵɵtemplate(85, LibLeaveSummaryComponent_div_85_Template, 7, 1, "div", 16);
        i0.ɵɵtemplate(86, LibLeaveSummaryComponent_86_Template, 1, 0, undefined, 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(14);
        i0.ɵɵtextInterpolate1(" ", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.employeeId) ? ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.employeeId : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.employeeName) ? ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.employeeName : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.employeeDesignation) ? ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.employeeDesignation : "--", " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.reportingManager) ? ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.reportingManager : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.startDate, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.endDate, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.appliedDate, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(53, 17, ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.appalyDuration));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.leaveSummaryDetails.leaveAllotmentList);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.leaveType) ? ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.leaveType : "--", " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.leaveRequestReason) ? ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.leaveRequestReason : "--", " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.phoneNumber) ? ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.phoneNumber : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.alternatePhoneNumber) ? ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.alternatePhoneNumber : "--", " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("value", ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.uploadDocuments)("resizableColumns", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.leaveStatus) === "Applied");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.leaveSummaryDetails == null ? null : ctx.leaveSummaryDetails.leaveStatus) === "Rejected");
    } }, directives: [i3.Accordion, i3.AccordionTab, i4.NgForOf, i5.Table, i6.PrimeTemplate, i4.NgIf, i7.MatIcon, i8.ButtonDirective], pipes: [i4.DecimalPipe], styles: [".leave_summary[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-weight:800}.leave_summary[_ngcontent-%COMP%]   .leave_details_content[_ngcontent-%COMP%], .leave_summary[_ngcontent-%COMP%]   .leave_details_heading[_ngcontent-%COMP%]{color:#000;font-size:14px;margin-bottom:10px}.leave_summary[_ngcontent-%COMP%]   .leave_details_heading[_ngcontent-%COMP%]{font-weight:600;margin-bottom:5px}.leave_summary[_ngcontent-%COMP%]   h6.leave_details_heading[_ngcontent-%COMP%]{font-weight:800;font-size:16px}.leave_summary[_ngcontent-%COMP%]   .leave_details_confirm[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#00bf00;cursor:pointer}.leave_summary[_ngcontent-%COMP%]   .leave_details_info[_ngcontent-%COMP%]{display:inline-block}.leave_summary[_ngcontent-%COMP%]   .leave_details_confirm_container[_ngcontent-%COMP%]{position:relative}.leave_summary[_ngcontent-%COMP%]   .leave_details_confirm_container[_ngcontent-%COMP%]:after{position:absolute;content:\"\";height:1px;width:95%;margin:0 auto;left:0;right:0;bottom:0;background:#ccc}.leave_summary[_ngcontent-%COMP%]   .leave-details-card-row[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding:8px 0;margin-left:8px}.leave_summary[_ngcontent-%COMP%]   .leave-details-card-row[_ngcontent-%COMP%]   .file-icons[_ngcontent-%COMP%]{position:relative;left:180px}.leave_summary[_ngcontent-%COMP%]   .file-name[_ngcontent-%COMP%]{color:#000}.leave_summary[_ngcontent-%COMP%]   .icon-color[_ngcontent-%COMP%]{color:#2196f3!important}.leave_summary[_ngcontent-%COMP%]   .download-icon[_ngcontent-%COMP%]{position:relative;top:2px;left:8px}.leave_summary[_ngcontent-%COMP%]   .labelHeading[_ngcontent-%COMP%]{font-size:14px;font-weight:600;color:#000;margin-left:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibLeaveSummaryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-leave-summary',
                templateUrl: 'lib-leave-summary.component.html',
                styleUrls: ['lib-leave-summary.component.scss']
            }]
    }], function () { return [{ type: LibLeaveSummaryService }, { type: i2.FileUploadLibraryService }]; }, null); })();

class LibLeaveSummaryModule {
}
LibLeaveSummaryModule.ɵfac = function LibLeaveSummaryModule_Factory(t) { return new (t || LibLeaveSummaryModule)(); };
LibLeaveSummaryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibLeaveSummaryModule });
LibLeaveSummaryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibLeaveSummaryModule, { declarations: [LibLeaveSummaryComponent], imports: [PrimengLibraryModule], exports: [LibLeaveSummaryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibLeaveSummaryModule, [{
        type: NgModule,
        args: [{
                declarations: [LibLeaveSummaryComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [LibLeaveSummaryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-leave-summary
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibLeaveSummaryComponent, LibLeaveSummaryModule, LibLeaveSummaryService };
//# sourceMappingURL=lib-leave-summary.js.map
